const prependAcFn = (acFn, collection) => {
	const memo = new Map();
	return Object.fromEntries(
		Object.entries(collection).map(
			([k, currentAcFn]) => {
				if(!memo.has(currentAcFn)){
					memo.set(currentAcFn, async (...args) => await acFn(...args) && await currentAcFn(...args))
				}
				return [k, memo.get(currentAcFn)];
			}
		)
	);
};
export default prependAcFn;
